/* eslint-disable @stylistic/max-len */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useRef, useState } from 'react'

import { mpfRListsHttp } from '../../../../assets/ts/api/mpf-r-lists-http'
import {
  addOrUpdateCommonMetadata,
  generateIncrementedCommonCode,
} from '../../../../assets/ts/data/common-metadata'
import { generateCode, scrollToTop } from '../../../../assets/ts/general/general'
import Alert from '../../../../components/alert/alert'
import Buttons from '../../../../components/buttons/buttons'
import { ALL_SELECT_VALUE, SELECT_LABEL, SELECT_OPTION } from '../../../../utils/constants/global-constants'
import { NO_CHANGE_MESSAGE } from '../../../../utils/constants/rhybus-config'
import CustomSelect from '../../../../utils/controls/custom-select'
import InputText from '../../../../utils/controls/input-text'
import { CSS, IsArchived } from '../../../../utils/controls/select-options-data'

interface Props {
  allCategories: string[]
  cancel: () => void
  editItems: any
  fetchCommonMetdata: () => void
  filtersvalue: any
  sectionOption: any
  showAddPopup: boolean
  showEdit?: any
  toggleView: () => void
}
const AddEditView = ({
  allCategories,
  cancel,
  editItems,
  fetchCommonMetdata,
  filtersvalue,
  sectionOption,
  showAddPopup,
  showEdit,
  toggleView,
}: Props) => {

  if (showAddPopup) {
    scrollToTop()
  }
  const [showAlert, setShowAlert] = useState(false)
  const titleRef = useRef<any>(null)

  const onClickAlert = async () => {
    setShowAlert(false)
  }
  const [inputValues, setInputValues] = useState({
    Archived: editItems?.archived ? editItems.archived : false,
    CSS: editItems?.css ? 'Yes' : 'No',
    Category: editItems?.category ? editItems.category : '',
    CategoryCode: editItems?.categoryCode ? editItems.categoryCode : ALL_SELECT_VALUE,
    Section: editItems?.section ? editItems.section : SELECT_LABEL,
    SectionCode: editItems?.sectionCode ? editItems.sectionCode : ALL_SELECT_VALUE,
  })
  const [metaDataCatOptions, setMetaDataCatOptions] = useState<any[]>([])

  const [categoryValidations, setCategoryValidations] = useState({
    Archived: false,
    CSS: false,
    Category: false,
    Section: false,
    TitleMsg: '',
  })

  const handleChange = (key: string, value: boolean | number | string) => {
    setInputValues((prev) => ({
      ...prev,
      [key]: value,
    }))
  }
  const changeSection = (e: { label: string; value: number }) => {
    handleChange('Section', e.label)
    handleChange('SectionCode', e.value)
  }

  const changeCSS = (e: { label: string; value: string }) => {
    handleChange('CSS', e.value)
  }
  const changeArchived = (e: { label: string; value: string }) => {
    handleChange('Archived', e.value)
  }

  const saveCategory = async () => {
    const userdetails = await mpfRListsHttp().me()
    const newCode = await generateIncrementedCommonCode()
    const userId = userdetails.userId
    const currentDate = new Date()

    const addUpdateObj = {
      AdditionalValue1: inputValues.CSS === 'Yes' ? true : false,
      AllowEdit: true,
      Code: inputValues.CategoryCode === -1 ? newCode : generateCode(inputValues.CategoryCode),
      IsArchived: inputValues.Archived,
      ItemCreated: currentDate,
      ItemCreatedBy: userId,
      ItemModified: currentDate,
      ItemModifiedBy: userId,
      MetadataType: 'Category',
      MetadataValue: inputValues.Category,
      OrgComponent: 'HAF', //may need to be updated dynamcially
      OrgLevel1: 'ALL',
      OrgLevel2: 'ALL',
      ParentCode: generateCode(inputValues.SectionCode),
      eKey: editItems ? editItems.eKey : '',
      eTag: editItems ? editItems.eTag : '',
    }
    let isNoChangesDetected = false
    const isCSS = inputValues.CSS === 'Yes'
    if (isCSS === editItems?.css &&
      inputValues.Category === editItems?.category &&
      inputValues.Section === editItems?.section &&
      inputValues.Archived === editItems?.archived
    ) {
      isNoChangesDetected = true
      setShowAlert(true)
    }


    if (!isNoChangesDetected) {
      try {
        await addOrUpdateCommonMetadata(addUpdateObj)
        cancel()
      } catch (error) {
        console.error(error)
        cancel()
      }
    }
  }

  const handleSubmit = async () => {
    let isValid = true
    const validations = {
      Archived: false,
      CSS: false,
      Category: false,
      Section: false,
      TitleMsg: '',
    }

    if (inputValues.Category === '') {
      isValid = false
      validations.Category = true
    }
    if (
      inputValues.Category !== '' &&
      allCategories.find(
        (category) => editItems?.category?.toLowerCase() !== inputValues?.Category.toLowerCase() && inputValues?.Category.toLowerCase() === category?.toLowerCase()
      )
    ) {
      isValid = false
      validations.Category = true
      validations.TitleMsg = 'This category already exist. Please enter unique category name.'
    }

    if (inputValues.SectionCode === -1) {
      isValid = false
      validations.Section = true
    }
    if (inputValues.CSS === '') {
      isValid = false
      validations.CSS = true
    }
    //add rest of validations
    setCategoryValidations(validations)
    if (isValid) {
      await saveCategory()
      await fetchCommonMetdata()
      //reset input values here
      toggleView()
    }
  }

  useEffect(() => {
    const titleElement = document.getElementById('Category')
    if (titleRef?.current) {
      titleRef?.current?.scrollIntoView(false)
      titleElement?.focus()
    }
  }, [titleRef, showEdit])
  useEffect(() => {
    sectionOption.shift()
    sectionOption.unshift(SELECT_OPTION)
    setMetaDataCatOptions(sectionOption)
  },[sectionOption])
  return (
    <div
      className={
        showAddPopup
          ? 'border-radius whitebg bordered15 mt-2'
          : 'settingseditpopup w-100 position-relative  border-top1 mt-2'
      }
      id={showAddPopup ? 'scroll' : ''}
    >
      {showAlert && (
        <Alert
          alerttextclass='poppins-semibold font-13 text-center'
          btn1className='btn btn btn-sm font-12 poppins-semibold btn-primary whitetext border-radius text-uppercase'
          btn1iconclassNmae='icon-checked font-12 pe-1'
          btn2classNmae='btn btn btn-border1 darktext btn-sm poppins-semibold font-12 border-radius text-uppercase'
          btn2iconclassNmae='icon-close color-primary font-12 pe-1'
          cancel='Cancel'
          className='alert-info'
          message={NO_CHANGE_MESSAGE}
          onClick={onClickAlert}
          yes='OK'
        />
      )}
      {showAddPopup && (
        <div className='p-3 border-bottom4'>
          <h4
            aria-label=' Add Category'
            className='m-0 p-0 d-inline-block font-15 poppins-semibold color-primary text-uppercase'
            tabIndex={0}
          >
            Add Category
          </h4>
        </div>
      )}
      <div className='px-2 py-1'>
        <div className='row'>
          <div
            className={showAddPopup ? 'col-sm-12 col-md-4 mb-2' : 'col-sm-12 col-md-4 mb-2'}
            ref={titleRef}
          >
            <InputText
              changeHandler={(e: any) => handleChange('Category', e.target.value)}
              className='form-lg font-13 sourcesanspro'
              error={categoryValidations?.Category}
              formClassName=' form-vertical'
              info='Category '
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'poppins-medium font-12 title-color2 mb-1',
                id: 'Category',
                name: ' Category',
                placeholder: 'Enter Category',
                value: inputValues?.Category,
              }}
              isInfo
              isMandatory
              label=' Category'
              uniqueErrormsg={categoryValidations?.TitleMsg}
              value={inputValues?.Category}
            />
          </div>
          <div className={showAddPopup ? 'col-sm-12 col-md-4 mb-2' : 'col-sm-12 col-md-4 mb-2'}>
            <CustomSelect
              className='form-lg w-100 sourcesanspro font-13 customselect'
              error={categoryValidations?.Section}
              formClassName='form-vertical'
              id='Section'
              info='Section '
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'mb-1 font-12 poppins-medium title-color',
                value: inputValues?.SectionCode,
              }}
              isInfo
              isMandatory
              label='Section'
              menuPosition={'fixed'}
              name='Section'
              onChange={changeSection}
              options={[...metaDataCatOptions]}
              value={inputValues?.SectionCode}
            />
          </div>
          <div className={showAddPopup ? 'col-sm-12 col-md-4 mb-2' : 'col-sm-12 col-md-4 mb-2'}>
            <CustomSelect
              className='form-lg w-100 sourcesanspro font-13 customselect'
              error={categoryValidations?.CSS}
              formClassName='form-vertical text-nowrap poppins-semibold font-11'
              id='CSS'
              info='CSS '
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'mb-1 font-12 poppins-medium title-color',
                value: inputValues?.CSS,
              }}
              isInfo
              isMandatory
              label='CSS'
              menuPosition={'fixed'}
              name='CSS'
              onChange={changeCSS}
              options={CSS}
              value={inputValues?.CSS}
            />
          </div>
          {!showAddPopup && (
            <div className='col-sm-12 col-lg-4 mb-2'>
              <CustomSelect
                className='form-lg w-100 sourcesanspro font-13 customselect'
                formClassName='form-vertical text-nowrap poppins-semibold font-11'
                id='IsArchived'
                info='IsArchived'
                infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
                infoIcon='icon-info color-primary'
                inputProps={{
                  className: 'mb-1 font-12 poppins-medium title-color',
                  value: inputValues?.Archived,
                }}
                isInfo
                isMandatory
                label='Is Archived'
                menuPortalTarget={document.body}
                menuPosition={'fixed'}
                name='Is Archived'
                onChange={changeArchived}
                options={IsArchived}
                value={inputValues?.Archived}
              />
            </div>
          )}
        </div>
        <div className='d-flex py-1 flex-wrap'>
          <div className='ms-auto settingsbtns d-flex'>
            {/* Add Section */}
            {showAddPopup && (
              <>
                <Buttons
                  className='btn-border-radius3 py-1 px-3 btn-bgcolor9  ms-2 whitetext poppins-medium font-12 text-uppercase btn-xs'
                  icon='icon-save font-11 pe-1'
                  label='Save'
                  onClick={handleSubmit}
                  type='button'
                />
                <Buttons
                  className='py-1 px-3 btn-border-radius3 btn-border1 ms-2 poppins-medium font-12 text-uppercase btn-xs'
                  icon='icon-close color-primary font-9 pe-1'
                  label='Cancel'
                  onClick={() => {
                    filtersvalue(!showAddPopup)
                  }}
                  type='button'
                />{' '}
              </>
            )}
            {/* Edit Section */}
            {!showAddPopup && (
              <>
                <Buttons
                  className='btn-border-radius3 py-1 px-3 btn-bgcolor9  ms-2 whitetext poppins-medium font-12 text-uppercase btn-xs'
                  icon='icon-update font-11 pe-1'
                  label='Update'
                  onClick={handleSubmit}
                  type='button'
                />
                <Buttons
                  className='py-1 px-3 btn-border-radius3 btn-border1 ms-2 poppins-medium font-12 text-uppercase btn-xs'
                  icon='icon-close color-primary font-9 pe-1'
                  label='Cancel'
                  onClick={() => {
                    cancel()
                  }}
                  type='button'
                />
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
export default AddEditView
